const AUTH_RETURN_TO_KEY = 'mizfa_auth_return_to';

function isSafeReturnPath(path: string): boolean {
  if (!path.startsWith('/') || path.startsWith('//')) return false;
  if (path.startsWith('/login') || path.startsWith('/callback')) return false;
  return true;
}

export function rememberAuthReturnTo(path: string): void {
  if (!isSafeReturnPath(path)) return;
  sessionStorage.setItem(AUTH_RETURN_TO_KEY, path);
}

export function peekAuthReturnTo(): string | null {
  const value = sessionStorage.getItem(AUTH_RETURN_TO_KEY);
  return value && isSafeReturnPath(value) ? value : null;
}

export function takeAuthReturnTo(): string | null {
  const value = peekAuthReturnTo();
  sessionStorage.removeItem(AUTH_RETURN_TO_KEY);
  return value;
}
